import { render, staticRenderFns } from "./SosMarker.vue?vue&type=template&id=a9e5eae6&scoped=true"
import script from "./SosMarker.vue?vue&type=script&lang=js"
export * from "./SosMarker.vue?vue&type=script&lang=js"
import style0 from "./SosMarker.vue?vue&type=style&index=0&id=a9e5eae6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e5eae6",
  null
  
)

export default component.exports